import { render, staticRenderFns } from "./Assessmenttaskxq.vue?vue&type=template&id=257b9f1e&scoped=true"
import script from "./Assessmenttaskxq.vue?vue&type=script&lang=js"
export * from "./Assessmenttaskxq.vue?vue&type=script&lang=js"
import style0 from "./Assessmenttaskxq.vue?vue&type=style&index=0&id=257b9f1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b9f1e",
  null
  
)

export default component.exports